import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AcceptWithdrawalService {
  constructor(private http: HttpClient) {}

  getSelectedWithdrawalDestination(
    playerId: number,
    paymentId: number,
    cardId: number
  ): Observable<WithdrawalsDestinationDTO> {
    return this.getWithdrawalsInfo(playerId).pipe(
      map((data: WithdrawalsInfoDTO) => {
        const destinations: WithdrawalsDestinationDTO[] = data.destinations;
        let selectedDestination: WithdrawalsDestinationDTO | null = null;

        destinations.forEach((element) => {
          if (element.id === paymentId) {
            if ((element.paymentMethod === 'CARD' && element.cardId === cardId) || element.paymentMethod !== 'CARD') {
              selectedDestination = element;
            }
          }
        });

        return selectedDestination;
      })
    );
  }

  getWithdrawalsInfo(playerId: number): Observable<WithdrawalsInfoDTO> {
    const params = new HttpParams().set('player-id', playerId).set('include-in-progress-withdrawals', 'false');
    return this.http.get<WithdrawalsInfoDTO>('/ordermanager/api/admin/v1/payments/withdrawals/info', {
      params: params,
    });
  }
}

export interface WithdrawalsDestinationDTO {
  id: number;
  paymentMethod: string;
  name: string;
  logo: string;
  withdrawalMinimum: string;
  withdrawalMaximum: string;
  disabled: boolean;
  cardId: number;
  cardNumber: string;
  cardLastFour: string;
  cardExpiryDate: string;
  closedLoopLevel: boolean;
  closedLoopRestricted: boolean;
  closedLoopMaximum: string;
}

export interface WithdrawalsInfoDTO {
  availableBalance: string;
  destinations: WithdrawalsDestinationDTO[];
}
